import { styled } from "@mui/material"

export const NoWrap = styled("span")({ whiteSpace: "nowrap" })
